const media = {
  tabletPlus: '600px'
}

export default media
